{
  "businessStructureOptions": [
    { "value": "SOLE_PROPRIETORSHIP", "label": "Sole Proprietorship" },
    { "value": "PARTNERSHIP", "label": "Partnership" },
    { "value": "LLC", "label": "Limited Liability Company (LLC)" },
    { "value": "CORPORATION", "label": "Corporation" },
    { "value": "NON_PROFIT", "label": "Non-profit" }
  ],
  "industryOptions": [
    { "value": "ACCOUNTING", "label": "Accounting" },
    { "value": "CONSTRUCTION", "label": "Construction / Home Services" },
    { "value": "INSURANCE", "label": "Insurance Services" },
    { "value": "LEGAL", "label": "Legal Services" },
    { "value": "MANUFACTURING", "label": "Manufacturing" },
    { "value": "NON_PROFIT_GOVERNMENT", "label": "Non Profit / Government" },
    { "value": "RETAIL_TRADE", "label": "Retail" },
    { "value": "TECHNOLOGY_SOFTWARE", "label": "Technology / Software" },
    { "value": "WHOLESALE_TRADE", "label": "Wholesale" },
    { "value": "OTHER", "label": "Other" }
  ],
  "yearsInBusinessOptions": [
    { "value": "LESS_THAN_1_YEAR", "label": "Less than 1 year" },
    { "value": "ONE_TO_TWO_YEARS", "label": "1 to 2 years" },
    { "value": "THREE_TO_FIVE_YEARS", "label": "3 to 5 years" },
    { "value": "SIX_TO_TEN_YEARS", "label": "6 to 10 years" },
    { "value": "TEN_TO_FIFTEEN_YEARS", "label": "10 to 15 years" },
    { "value": "SIXTEEN_TO_TWENTY_YEARS", "label": "16 to 20 years" },
    { "value": "OVER_TWENTY_YEARS", "label": "20+ years" }
  ]
}
